<template>
  <div class="admin-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar filter-bar--end">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增管理员</el-button>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && list.length === 0" description="暂无管理员" />

      <template v-else>
        <el-table :data="list" border stripe v-loading="loading" row-key="id">
          <el-table-column prop="id" label="ID" width="80" align="center" />
          <el-table-column prop="username" label="账号" min-width="140" />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 0" type="success" size="small">正常</el-tag>
              <el-tag v-else type="danger" size="small">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="toggleStatus(scope.row)"
              >{{ scope.row.status === 0 ? '禁用' : '启用' }}</el-button>
              <el-button
                type="text"
                size="small"
                class="danger-text"
                @click="handleDelete(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="p => { pagination.page = p; fetchList() }"
            @size-change="s => { pagination.pageSize = s; pagination.page = 1; fetchList() }"
          />
        </div>
      </template>
    </el-card>

    <el-dialog title="新增管理员" :visible.sync="dialogVisible" width="420px" append-to-body>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="账号" prop="username">
          <el-input v-model.trim="form.username" maxlength="16" placeholder="账号" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" show-password maxlength="32" placeholder="6-32位密码" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del, getResponseMessage } from '@/utils/http.js'

export default {
  name: 'AdminManagement',
  data() {
    return {
      loading: false,
      submitting: false,
      error: '',
      list: [],
      pagination: { page: 1, pageSize: 20, total: 0 },
      dialogVisible: false,
      form: { username: '', password: '' },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 32, message: '密码长度 6-32 位', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const res = await get('/admin/page', {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        })
        const data = res.data || {}
        this.list = data.records || []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.list = []
        this.error = e.message || '加载失败'
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.form = { username: '', password: '' }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await post('/admin/create', this.form)
          this.$message.success('已添加管理员')
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(getResponseMessage(e) || e.message || '添加失败')
        } finally {
          this.submitting = false
        }
      })
    },
    async toggleStatus(row) {
      const next = row.status === 0 ? 1 : 0
      const tip = next === 1 ? '禁用' : '启用'
      try {
        await this.$confirm(`确定${tip}账号「${row.username}」吗？`, '提示', { type: 'warning' })
        await put(`/admin/${row.id}`, { status: next })
        this.$message.success(`已${tip}`)
        this.fetchList()
      } catch (e) {
        if (e === 'cancel' || e === 'close') return
        this.$message.error(getResponseMessage(e) || e.message || '操作失败')
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确定删除管理员「${row.username}」吗？`, '提示', { type: 'warning' })
        await del(`/admin/${row.id}`)
        this.$message.success('已删除')
        this.fetchList()
      } catch (e) {
        if (e === 'cancel' || e === 'close') return
        this.$message.error(getResponseMessage(e) || e.message || '删除失败')
      }
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 16px;
}
.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
}
.filter-bar--end {
  justify-content: flex-end;
}
.hint {
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
  flex: 1;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
.error { color: #f56c6c; margin-bottom: 12px; }
.danger-text { color: #f56c6c; }
.muted { color: #94a3b8; }
</style>
